import { FiMapPin } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const CepField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    mask="cep"
    placeholder={field.placeholder || field.label || 'CEP'}
    icon={FiMapPin}
    disabled={disabled}
    required={field.is_required}
    inputMode="numeric"
  />
);

export default CepField;
